import React, { useContext } from 'react';
import { VStack, Button, Box, HStack } from '@wegroup/design-system';
import ToolbarLogo from './ToolbarLogo';
import ToolbarBackToDashboardButton from './ToolbarBackToDashboardButton';
import { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';
import useIsImmo from '../../../../../../../common/src/hooks/useIsImmo';
import FlowsToolbarFooter from './FlowsToolbarFooter';
import useAuth from '../../../../../../../app/src/features/authentication/hooks/useAuth';
import LanguageChangeMenu from '../LanguageChangeMenu';
import { isSocialLoginUrl } from '../../../../../../../app/src/features/authentication/constants/SocialAuth';

const ToolbarDesktop: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const theme = useContext(ThemeContext);
  const isImmo = useIsImmo();
  const { distribution, campaign } = useAuth();

  const logoUrl =
    campaign?.logo ||
    distribution?.logos?.logo_fe ||
    distribution?.logos?.logo_fe ||
    distribution?.logos?.logo ||
    theme.branding?.logo;

  return (
    <VStack
      data-test-id="ProdFac_Toolbar"
      pt="8"
      pr="10"
      pb="6"
      pl="6"
      zIndex="3"
      alignItems="stretch"
      justifyContent="flex-start"
      bgColor={isImmo ? 'secondary.700' : 'secondary.800'}
      minW="8"
      borderTopRightRadius="20px"
      borderBottomRightRadius="20px"
      color="white"
      w="100%"
      h="100%"
      maxH="100vh"
      overflowY="hidden"
      maxW={{
        base: '80',
        laptopL: '96',
      }}
      spacing={{ base: '2', laptopL: '8' }}
    >
      <div>
        <ToolbarLogo url={logoUrl} />
      </div>
      {!isSocialLoginUrl && (
        <ToolbarBackToDashboardButton
          alertText={t(
            'Are you sure you want to go back? All session data is saved and can be retrieved trough conversation history',
          )}
        />
      )}
      <Box
        flexGrow={1}
        pos="relative"
        overflowY="auto"
        sx={{
          '&::-webkit-scrollbar': {
            WebkitAppearance: 'none',
            display: 'none',
          },
        }}
      >
        {children}
      </Box>
      <VStack align="stretch" spacing={{ base: '2', laptopL: '8' }}>
        <LanguageChangeMenu />
        <HStack spacing="4" align="flex-end">
          <VStack align="left" spacing="2">
            {distribution.privacy_page_url && (
              <Button
                variant="link"
                alignSelf="flex-start"
                href={distribution.privacy_page_url}
                color="secondary.300"
                fontSize="small"
                target="_blank"
                as="a"
              >
                {t('Privacy')}
              </Button>
            )}

            <FlowsToolbarFooter />
          </VStack>
        </HStack>
      </VStack>
    </VStack>
  );
};

export default ToolbarDesktop;
